import React from 'react';
import PropTypes from 'prop-types';
import { classNameWithModifiers as withMods } from 'helpers/class-name';

import './LoadingDots.scss';

const LoadingDots = ({ className }) => (
  <div className={withMods('loading-dots', className)} data-testid="loading-dots">
    <div className="loading-dots__dot loading-dots__dot--one" />
    <div className="loading-dots__dot loading-dots__dot--two" />
    <div className="loading-dots__dot loading-dots__dot--three" />
  </div>
);

LoadingDots.propTypes = {
  className: PropTypes.string,
};

export default LoadingDots;
